<template>
  <fragment>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="2"
          label="Categoria"
          item-text="descricao"
          item-value="idcategoria"
          placeholder="Selecione uma categoria"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.categorias_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col>
        <BaseMoneyField
          required
          tabindex="3"
          label="Preço"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="1"
          label="Status"
          item-text="value"
          item-value="key"
          placeholder="Selecione o status do produto"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.status_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
      <v-col cols="6">
        <BaseTextField
          :required="requiredUrl"
          label="URL do Link"
          placeholder="Insira a url do Link"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.url_link"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseTextField
          label="Local do evento"
          placeholder="Insira o local do evento"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.endereco"
        />
      </v-col>
      <v-col cols="6">
        <BaseAutocomplete
          label="País"
          item-text="dsc_lang"
          return-object
          placeholder="Selecione o país"
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_paises"
          :items="$config.paises.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pais"
        >
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseAutocomplete
          label="Estado"
          item-text="dsc_lang"
          item-value="iso_full"
          return-object
          placeholder="Selecione o estado"
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_estados"
          :items="$config.estados.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.estado"
        >
        </BaseAutocomplete>
      </v-col>
      <v-col cols="6">
        <BaseAutocomplete
          label="Cidade"
          item-text="dsc_lang"
          item-value="dsc_lang"
          placeholder="Selecione a cidade"
          :loading="$config.loading_cidades"
          :items="$config.cidades.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.cidade"
        >
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseTextField
          label="Data e hora do evento"
          type="datetime"
          v-mask="'##/##/#### ##:##'"
          placeholder="dd/mm/aaaa hh:mm"
          append-icon="mdi-calendar"
          persistent-hint
          :rules="dateRequired"
          :hint="apresentationDateExplain"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          label="Produto em destaque"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
const { products, formRules } = mixins;
export default {
  name: "LinkProduct",
  mixins: [products, formRules],
  components: {
    BaseSelect,
    BaseMoneyField,
    BaseTextField,
    BaseAutocomplete,
  },
  data: () => ({
    pais: "9e1bf96ca2754ee6596f26fd6e6b5cc2",
    descricao: "",
    descritivo: "",
    apresentationDateExplain:
      "ℹ️ Necessário informar uma data para o evento - essa data pode ser fixa (utilizar esse campo) ou variável (utilizar as opções do evento e incluir pelo menos uma opção de data).",
  }),
  computed: {
    dateRequired() {
      const courtesyAndTicket =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA";
      const someProductWithOptionDate =
        this.$produtos_gerenciar.cadastro.variacoes.opcoes.some(item => {
          return item.tipo === "DATA";
        });

      return courtesyAndTicket && !someProductWithOptionDate
        ? [this.rules.required]
        : [];
    },
    requiredUrl() {
      return !this.$produtos_gerenciar.cadastro.dados_cadastrais
        .prod_agrupamento;
    },
  },
  methods: {
    waitForEstadosResult() {
      return new Promise(resolve => {
        const checkEstados = () => {
          if (this.$config.estados && this.$config.estados.result) {
            resolve();
          } else {
            setTimeout(checkEstados, 50);
          }
        };
        checkEstados();
      });
    },
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.pais": {
      handler(country) {
        const { id } = country;
        this.$config.getEstados(id || "9e1bf96ca2754ee6596f26fd6e6b5cc2");
      },
      deep: true,
      immediate: true,
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.estado": {
      async handler(state) {
        if (!state || !this.$config.estados) return;
        await this.waitForEstadosResult();

        const { id } = state;
        const filteredId = this.$config.estados.result.find(
          item => item.iso === state || item.id === id
        );
        if (filteredId) {
          await this.$nextTick();
          this.$config.getCidades(id || filteredId.id);
        } else {
          console.warn("State not found:", state);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$config.getPaises();
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.pais) {
      this.pais = this.$produtos_gerenciar.cadastro.dados_cadastrais.pais;
    }

    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.estado) {
      this.estado = this.$produtos_gerenciar.cadastro.dados_cadastrais.estado;
    }
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.cidade) {
      this.cidade = this.$produtos_gerenciar.cadastro.dados_cadastrais.cidade;
    }
  },
};
</script>
<style></style>
